var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-row",
    [
      _c(
        "v-col",
        { attrs: { cols: "12" } },
        [
          _c(
            "v-form",
            { ref: "form" },
            [
              _c(
                "base-card",
                [
                  _c("v-card-title", [_vm._v("Registrar Emisor FE")]),
                  _c(
                    "v-card-text",
                    [
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "12", sm: "4" } },
                            [
                              _c("v-select", {
                                ref: "Compania",
                                attrs: {
                                  items: _vm.detailClients,
                                  "item-text": "NombreCompania",
                                  "item-value": "IdCompania",
                                  label: "Compañia",
                                  "prepend-inner-icon": "mdi-sitemap",
                                  rules: _vm.formRules,
                                  "error-messages": _vm.errorMessages,
                                  filter: "",
                                  "search-input": "",
                                  required: "",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "prepend-item",
                                    fn: function () {
                                      return [
                                        _c(
                                          "v-list-item",
                                          [
                                            _c(
                                              "v-list-item-content",
                                              [
                                                _c(
                                                  "v-list-item-title",
                                                  [
                                                    _c("v-text-field", {
                                                      staticClass:
                                                        "search-field",
                                                      attrs: {
                                                        placeholder: "Buscar",
                                                        "prepend-inner-icon":
                                                          "mdi-magnify",
                                                        "hide-details": "",
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.searchClients,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.searchClients =
                                                            $$v
                                                        },
                                                        expression:
                                                          "searchClients",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                ]),
                                model: {
                                  value: _vm.dataEmisor.Compania,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.dataEmisor, "Compania", $$v)
                                  },
                                  expression: "dataEmisor.Compania",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "12", sm: "4" } },
                            [
                              _c("v-text-field", {
                                ref: "Nit",
                                attrs: {
                                  "error-messages": _vm.errorMessages,
                                  clearable: "",
                                  type: "number",
                                  label: "Nit",
                                  rules: _vm.nitFormRules,
                                  "prepend-inner-icon": "mdi-card",
                                  required: "",
                                },
                                model: {
                                  value: _vm.dataEmisor.Nit,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.dataEmisor, "Nit", $$v)
                                  },
                                  expression: "dataEmisor.Nit",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "12", sm: "4" } },
                            [
                              _c("v-select", {
                                ref: "TipoIdentificacion",
                                attrs: {
                                  "error-messages": _vm.errorMessages,
                                  items: _vm.listTypeDocument,
                                  rules: _vm.formRules,
                                  "item-text": "textTypeDocument",
                                  "item-value": "valueTypeDocument",
                                  label: "Tipo Identificación",
                                  "prepend-inner-icon": "mdi-account-network",
                                  required: "",
                                },
                                model: {
                                  value: _vm.dataEmisor.TipoIdentificacion,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.dataEmisor,
                                      "TipoIdentificacion",
                                      $$v
                                    )
                                  },
                                  expression: "dataEmisor.TipoIdentificacion",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "12", sm: "4" } },
                            [
                              _c("v-select", {
                                ref: "TipoPersona",
                                attrs: {
                                  "error-messages": _vm.errorMessages,
                                  items: _vm.listTypePerson,
                                  rules: _vm.formRules,
                                  "item-text": "textTypePerson",
                                  "item-value": "valueTypePerson",
                                  label: "Tipo Persona",
                                  "prepend-inner-icon": "mdi-file-chart",
                                  required: "",
                                },
                                model: {
                                  value: _vm.dataEmisor.TipoPersona,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.dataEmisor, "TipoPersona", $$v)
                                  },
                                  expression: "dataEmisor.TipoPersona",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "12", sm: "3" } },
                            [
                              _c("v-text-field", {
                                ref: "NombreComercial",
                                attrs: {
                                  "error-messages": _vm.errorMessages,
                                  rules: _vm.formRules,
                                  clearable: "",
                                  label: "Nombre Comercial",
                                  "prepend-inner-icon": "mdi-account-tie",
                                  required: "",
                                },
                                model: {
                                  value: _vm.dataEmisor.NombreComercial,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.dataEmisor,
                                      "NombreComercial",
                                      $$v
                                    )
                                  },
                                  expression: "dataEmisor.NombreComercial",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "12", sm: "3" } },
                            [
                              _c("v-text-field", {
                                ref: "NombreComercialHioffice",
                                attrs: {
                                  clearable: "",
                                  label: "Nombre Comercial Hioffice",
                                  "prepend-inner-icon": "mdi-account-tie",
                                },
                                model: {
                                  value: _vm.dataEmisor.NombreComercialHioffice,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.dataEmisor,
                                      "NombreComercialHioffice",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "dataEmisor.NombreComercialHioffice",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "12", sm: "6" } },
                            [
                              _c("v-text-field", {
                                directives: [
                                  {
                                    name: "can",
                                    rawName: "v-can",
                                    value: "Visualizar RazonSocial RE",
                                    expression: "'Visualizar RazonSocial RE'",
                                  },
                                ],
                                ref: "RazonSocial",
                                attrs: {
                                  "error-messages": _vm.errorMessages,
                                  rules: _vm.formRules,
                                  clearable: "",
                                  label: "Razon Social",
                                  "prepend-inner-icon": "mdi-account-tie",
                                  required: "",
                                },
                                model: {
                                  value: _vm.dataEmisor.RazonSocial,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.dataEmisor, "RazonSocial", $$v)
                                  },
                                  expression: "dataEmisor.RazonSocial",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "12", sm: "6" } },
                            [
                              _c("v-select", {
                                ref: "Tributo",
                                attrs: {
                                  "error-messages": _vm.errorMessages,
                                  items: _vm.listTributo,
                                  rules: _vm.formRules,
                                  "item-text": "textTributo",
                                  "item-value": "valueTributo",
                                  label: "Tributo",
                                  "prepend-inner-icon": "mdi-file-chart",
                                  required: "",
                                },
                                model: {
                                  value: _vm.dataEmisor.Tributo,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.dataEmisor, "Tributo", $$v)
                                  },
                                  expression: "dataEmisor.Tributo",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "12", sm: "6" } },
                            [
                              _c("v-select", {
                                ref: "Obligaciones",
                                attrs: {
                                  "error-messages": _vm.errorMessages,
                                  items: _vm.listObligaciones,
                                  rules: _vm.formRules,
                                  "item-text": "textObligaciones",
                                  "item-value": "valueObligaciones",
                                  label: "Obligaciones",
                                  "prepend-inner-icon": "mdi-file-chart",
                                  required: "",
                                  multiple: "",
                                },
                                model: {
                                  value: _vm.dataEmisor.Obligaciones,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.dataEmisor,
                                      "Obligaciones",
                                      $$v
                                    )
                                  },
                                  expression: "dataEmisor.Obligaciones",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "12", sm: "4" } },
                            [
                              _c("v-text-field", {
                                ref: "NombreContacto",
                                attrs: {
                                  "error-messages": _vm.errorMessages,
                                  rules: _vm.formRules,
                                  clearable: "",
                                  label: "Nombre Contacto",
                                  "prepend-inner-icon": "mdi-account-tie",
                                  required: "",
                                },
                                model: {
                                  value: _vm.dataEmisor.NombreContacto,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.dataEmisor,
                                      "NombreContacto",
                                      $$v
                                    )
                                  },
                                  expression: "dataEmisor.NombreContacto",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "12", sm: "4" } },
                            [
                              _c("v-text-field", {
                                directives: [
                                  {
                                    name: "can",
                                    rawName: "v-can",
                                    value: "Visualizar EmailContacto RE",
                                    expression: "'Visualizar EmailContacto RE'",
                                  },
                                ],
                                ref: "EmailContacto",
                                attrs: {
                                  "error-messages": _vm.errorMessages,
                                  type: "email",
                                  rules: _vm.emailRules,
                                  clearable: "",
                                  label: "Email Contacto",
                                  "prepend-inner-icon": "mdi-email",
                                  required: "",
                                },
                                model: {
                                  value: _vm.dataEmisor.EmailContacto,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.dataEmisor,
                                      "EmailContacto",
                                      $$v
                                    )
                                  },
                                  expression: "dataEmisor.EmailContacto",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "12", sm: "4" } },
                            [
                              _c("v-text-field", {
                                directives: [
                                  {
                                    name: "can",
                                    rawName: "v-can",
                                    value: "Visualizar TelefonoContacto RE",
                                    expression:
                                      "'Visualizar TelefonoContacto RE'",
                                  },
                                ],
                                ref: "TelefonoContacto",
                                attrs: {
                                  "error-messages": _vm.errorMessages,
                                  rules: _vm.formRules,
                                  clearable: "",
                                  type: "number",
                                  label: "Teléfono Contacto",
                                  "prepend-inner-icon": "mdi-phone",
                                  required: "",
                                },
                                model: {
                                  value: _vm.dataEmisor.TelefonoContacto,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.dataEmisor,
                                      "TelefonoContacto",
                                      $$v
                                    )
                                  },
                                  expression: "dataEmisor.TelefonoContacto",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "12", sm: "4" } },
                            [
                              _c("v-select", {
                                ref: "Departamento",
                                attrs: {
                                  items: _vm.detailDepartaments,
                                  "item-text": "nombre",
                                  "item-value": "idProvincia",
                                  label: "Departamento",
                                  "prepend-inner-icon": "mdi-map",
                                  rules: _vm.formRules,
                                  "error-messages": _vm.errorMessages,
                                  filter: "",
                                  "search-input": "",
                                  required: "",
                                },
                                on: { change: _vm.getCitys },
                                scopedSlots: _vm._u([
                                  {
                                    key: "prepend-item",
                                    fn: function () {
                                      return [
                                        _c(
                                          "v-list-item",
                                          [
                                            _c(
                                              "v-list-item-content",
                                              [
                                                _c(
                                                  "v-list-item-title",
                                                  [
                                                    _c("v-text-field", {
                                                      staticClass:
                                                        "search-field",
                                                      attrs: {
                                                        placeholder: "Buscar",
                                                        "prepend-inner-icon":
                                                          "mdi-magnify",
                                                        "hide-details": "",
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.searchDepatartaments,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.searchDepatartaments =
                                                            $$v
                                                        },
                                                        expression:
                                                          "searchDepatartaments",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                ]),
                                model: {
                                  value: _vm.dataEmisor.Departamento,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.dataEmisor,
                                      "Departamento",
                                      $$v
                                    )
                                  },
                                  expression: "dataEmisor.Departamento",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "12", sm: "4" } },
                            [
                              _c("v-select", {
                                ref: "Ciudad",
                                attrs: {
                                  items: _vm.detailCitys,
                                  "item-text": "nombre",
                                  "item-value": "idPoblacion",
                                  label: "Ciudad",
                                  "prepend-inner-icon": "mdi-city",
                                  rules: _vm.formRules,
                                  "error-messages": _vm.errorMessages,
                                  filter: "",
                                  "search-input": "",
                                  required: "",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "prepend-item",
                                    fn: function () {
                                      return [
                                        _c(
                                          "v-list-item",
                                          [
                                            _c(
                                              "v-list-item-content",
                                              [
                                                _c(
                                                  "v-list-item-title",
                                                  [
                                                    _c("v-text-field", {
                                                      staticClass:
                                                        "search-field",
                                                      attrs: {
                                                        placeholder: "Buscar",
                                                        "prepend-inner-icon":
                                                          "mdi-magnify",
                                                        "hide-details": "",
                                                      },
                                                      model: {
                                                        value: _vm.searchCitys,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.searchCitys = $$v
                                                        },
                                                        expression:
                                                          "searchCitys",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                ]),
                                model: {
                                  value: _vm.dataEmisor.Ciudad,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.dataEmisor, "Ciudad", $$v)
                                  },
                                  expression: "dataEmisor.Ciudad",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "12", sm: "4" } },
                            [
                              _c("v-text-field", {
                                directives: [
                                  {
                                    name: "can",
                                    rawName: "v-can",
                                    value: "Visualizar Direccion RE",
                                    expression: "'Visualizar Direccion RE'",
                                  },
                                ],
                                ref: "Direccion",
                                attrs: {
                                  "error-messages": _vm.errorMessages,
                                  rules: _vm.formRules,
                                  clearable: "",
                                  label: "Direccion",
                                  "prepend-inner-icon": "mdi-home",
                                  required: "",
                                },
                                model: {
                                  value: _vm.dataEmisor.Direccion,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.dataEmisor, "Direccion", $$v)
                                  },
                                  expression: "dataEmisor.Direccion",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "12", sm: "4" } },
                            [
                              _c("v-text-field", {
                                ref: "EncabezadoLeyenda",
                                attrs: {
                                  clearable: "",
                                  label: "Encabezado Leyenda",
                                  "prepend-inner-icon": "mdi-text",
                                },
                                model: {
                                  value: _vm.dataEmisor.EncabezadoLeyenda,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.dataEmisor,
                                      "EncabezadoLeyenda",
                                      $$v
                                    )
                                  },
                                  expression: "dataEmisor.EncabezadoLeyenda",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "12", sm: "8" } },
                            [
                              _c("v-textarea", {
                                ref: "DetalleLeyenda",
                                attrs: {
                                  clearable: "",
                                  rows: "3",
                                  "auto-grow": "",
                                  label: "Detalle Leyenda",
                                  "prepend-inner-icon": "mdi-text",
                                },
                                model: {
                                  value: _vm.dataEmisor.LeyendaText,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.dataEmisor, "LeyendaText", $$v)
                                  },
                                  expression: "dataEmisor.LeyendaText",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "12", sm: "4" } },
                            [
                              _c(
                                "v-btn",
                                {
                                  staticClass: "ma-2",
                                  staticStyle: {
                                    "background-color": "rgb(204 33 40)",
                                    color: "white !important",
                                  },
                                  on: { click: _vm.validateEmisor },
                                },
                                [_vm._v(" Registrar ")]
                              ),
                              _c(
                                "v-btn",
                                {
                                  staticClass: "ma-3",
                                  attrs: { color: "GRAY" },
                                  on: { click: _vm.limpiarFormulario },
                                },
                                [_vm._v(" Limpiar ")]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "12", sm: "8" } },
                            [
                              _c(
                                "v-alert",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.successAlert,
                                      expression: "successAlert",
                                    },
                                  ],
                                  attrs: { type: _vm.alertType, text: "" },
                                },
                                [_vm._v(" " + _vm._s(_vm.msgAlert) + " ")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }